var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "login-change" } }, [
    _vm.isLoggedIn
      ? _c("div", { staticClass: "dropdown" }, [
          _c(
            "a",
            {
              staticClass: "dropdown-toggle",
              attrs: {
                href: "#",
                id: "accountMenuList",
                "data-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false",
                "data-boundary": "window",
              },
            },
            [
              _c("i", {
                staticClass: "fa fa-user d-sm-none",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "d-none d-sm-inline" }, [
                _vm._v(
                  _vm._s(
                    _vm.$translate("Ceres::Template.loginHello", {
                      username: _vm.username,
                    })
                  )
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "account-menu dropdown-menu dropdown-menu-right small",
            },
            [
              _c(
                "div",
                {
                  staticClass: "list-group",
                  attrs: { "aria-labelledby": "accountMenuList" },
                },
                [
                  _c("a", { attrs: { href: _vm.$ceres.urls.myAccount } }, [
                    _c("i", {
                      staticClass: "fa fa-user",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$translate("Ceres::Template.loginMyAccount"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      directives: [{ name: "logout", rawName: "v-logout" }],
                      attrs: { href: "#" },
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-sign-out",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$translate("Ceres::Template.loginLogout"))
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isLoggedIn
      ? _c("div", [
          _c(
            "a",
            {
              attrs: {
                href: _vm.isLogin ? "javascript:void(0)" : "#login",
                "data-toggle": _vm.isLogin ? false : "modal",
                id: "accountMenuList",
                "aria-haspopup": "true",
                "aria-expanded": "false",
                "data-boundary": "window",
                "aria-label": _vm.$translate(
                  "ODElvirasBastelmaterial::Template.bfsgHeaderBasketLoginRegisterLabel"
                ),
              },
              on: {
                click: function ($event) {
                  _vm.createLoginModal()
                  _vm.unmarkInputFields()
                },
              },
            },
            [
              _c("i", {
                staticClass: "fa fa-user",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "d-none d-sm-inline" }, [
                _vm._v(_vm._s(_vm.$translate("Ceres::Template.login"))),
              ]),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }